export default "__VITE_ASSET__ee5ad0df__$_?react__"